<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.specialOperationCode')"
    width="600px"
    :close-on-click-modal="false"
    class="app-main-inner"
  >
    <div style="display:flex;flex-direction:row;padding-bottom:5px">
      <el-input v-model="keyword" :placeholder="$t('SeaExport.PleaseInputAKeyword')" style="width:250px" no="1" />
    </div>
    <cargo-ag-grid
      :show-side-bar="false"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      style="width:100%;height:300px"
      @gridReady="params=>{gridApi=params.api}"
    />
    <div slot="footer" style="margin: 0 auto;width: fit-content;">
      <el-button type="primary" no="2" @click="confirm">{{ $t('CargoMsg.Cargo_ConfirmR') }}</el-button>
      <el-button no="3" @click="innerVisible=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getSpecialOperationCodeList } from '@/api/operation'

export default {
  name: 'SelectOperationReqDialog',
  components: { },
  props: {
    visible: { type: Boolean, required: true },
    lob: { type: String, default: '' },
    value: { type: String, default: '' }
  },
  data() {
    return {
      firstShow: true,
      innerVisible: false,
      innerValue: '',
      keyword: '',
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        onSelectionChanged: () => {
          this.onRowClicked()
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '',
          headerCheckboxSelection: true,
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Code'),
          field: 'code',
          suppressMenu: true,
          width: 100,
          onCellDoubleClicked: event => {
            this.copyText(event.data.code)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ContentDescription'),
          field: 'description',
          suppressMenu: true,
          flex: 1,
          tooltipValueGetter: (params) => {
            return params.value
          },
          onCellDoubleClicked: event => {
            this.copyText(event.data.description)
          }
        }
      ],
      rawData: [],
      rowData: [],
      gridApi: null
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
        if (newVal && this.firstShow) {
          this.firstShow = false
          this.toQuery()
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    },
    lob(newVal) {
      this.toQuery()
    },
    value(newVal) {
      this.innerValue = newVal
      this.setGridSelect()
    },
    keyword(newVal) {
      this.filterRawData()
    }
  },
  created() {
    if (this.value) {
      this.innerValue = this.value
    }
  },
  methods: {
    async toQuery() {
      const res = await getSpecialOperationCodeList({ businessType: this.lob })
      this.rawData = res.data.list || []
      this.filterRawData()
    },
    filterRawData() {
      this.rowData = this.rawData.filter(p => {
        if (this.keyword) {
          return p.code.indexOf(this.keyword) > -1 || p.description.indexOf(this.keyword) > -1
        }
        return true
      })
      this.$nextTick(() => {
        this.setGridSelect()
      })
    },
    setGridSelect() {
      if (!this.gridApi) {
        return
      }
      this.gridApi.clearFocusedCell()
      this.gridApi.deselectAll()
      if (!this.innerValue) {
        const nodes = this.gridApi.getRenderedNodes()
        for (const item of nodes) {
          item.setSelected(false)
        }
        return
      }
      const valueSet = new Set(this.innerValue.split(','))
      const nodes = this.gridApi.getRenderedNodes()
      for (const item of nodes) {
        if (valueSet.has(item.data.code)) {
          item.setSelected(true)
        }
      }
    },
    onRowClicked() {
      const rows = this.gridApi.getSelectedRows()
      let text = ''
      for (const item of rows) {
        if (text) {
          text += ','
        }
        text += item.code
      }
      this.innerValue = text
    },
    confirm() {
      this.$emit('callback', this.innerValue)
      this.innerVisible = false
    },
    copyText(text) {
      const textarea = document.createElement('textarea')
      document.body.appendChild(textarea)
      textarea.textContent = text
      textarea.select()
      if (document.execCommand('copy')) {
        document.execCommand('copy')
      }
      document.body.removeChild(textarea)
      this.$message.success(this.$t('SeaExport.CopySuccess'))
    }
  }
}
</script>

<style>
</style>
